import { isNode, environ, joinPath } from "@ihr-radioedit/sdk-utils";
export var Scheme;
(function (Scheme) {
    Scheme[Scheme["INSECURE"] = 0] = "INSECURE";
    Scheme[Scheme["SECURE"] = 1] = "SECURE";
    Scheme[Scheme["RELATIVE"] = 2] = "RELATIVE";
})(Scheme || (Scheme = {}));
export const schemeURLPrefix = (scheme) => {
    switch (scheme) {
        case Scheme.INSECURE:
            return "http://";
        case Scheme.SECURE:
            return "https://";
        case Scheme.RELATIVE:
            return isNode ? "https://" : "//";
    }
    throw new Error("Not possible.");
};
export const getServiceURL = (serviceId, pathPrefix = "", override, scheme = Scheme.RELATIVE) => {
    if (!override && !environ.hasDep(serviceId)) {
        throw new Error(`Auto connection needs declared dependency on ${serviceId} or a baseURL`);
    }
    return override ? override : joinPath(`${schemeURLPrefix(scheme)}${environ.dep(serviceId)}`, pathPrefix);
};
//# sourceMappingURL=scheme.js.map